@if (studyRoomDataList !='') {
<div class="box studyroomListView">
  <table class="table is-striped is-narrow is-hoverable is-fullwidth">
    <thead>
      <tr>
        <th>Topic / Assignment</th>
        <!-- <th>Published Date</th> -->
        <th>Type</th>
        <th>Submission Date</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (data of studyRoomDataList; track data; let i = $index) {
      <tr>
        <td style="text-transform: capitalize">{{ data.topic }}</td>
        <!-- <td>{{data.updated_at | date: 'dd MMM yyyy'}}</td> -->
        <td>
          @if (data.staff_type=='A') {
          <span> Assignment </span>
          } @else { Topic }
        </td>
        <td>{{ data.shedule_date | date : "MMM d, y" }}</td>
        <td>
          <a
            class="button is-small has-tooltip-top"
            data-tooltip="View Topic/Assignment"
            (click)="viewCurrentTopic(data.topic_id)"
          >
            <i class="fa fa-eye" aria-hidden="true"></i
          ></a>
          @if (data.file_type === 'video' || data.file_type === 'audio') {
          <div style="float: left">
            @if (data.file_path!= null) {
            <a
              class="button is-small has-tooltip-top"
              data-tooltip="Play"
              (click)="playMedia(data)"
            >
              <i class="fa fa-play is-small" aria-hidden="true"></i>
            </a>
            }
          </div>
          } @else {
          <!-- <a class="button is-small has-tooltip-top" data-tooltip="View Files" (click)="secureReadfile(data)" *ngIf="data.file_path!= null">
                  <i class="fa fa-file-text is-small" aria-hidden="true"></i>
                </a> -->
          } @if (data.staff_type=='A') {
          <a
            class="button is-small"
            data-tooltip="Upload Assignment here..."
            (click)="uploadAssignmentModal(data, data.topic_id)"
          >
            <i class="fa fa-upload" aria-hidden="true"></i>
          </a>
          } @if (data.staff_type=='A') {
          <a
            class="button is-small"
            data-tooltip="View FeedBack"
            (click)="reviewFeedBack(data.topic_id)"
          >
            <i class="fa fa-commenting-o" aria-hidden="true"></i>
          </a>
          } @if (data.file_id!==null) {
          <a
            class="button is-small"
            data-tooltip="Download File"
            (click)="secureFileDownLoad(data)"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </a>
          }
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>
}

<div class="showAssignment">
  <div
    class="modal"
    [ngClass]="{ 'is-modal-active': showAssignmentModal[isTopicId] }"
  >
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card">
        <form [formGroup]="uploadAssignForm">
          <div class="card-header">
            <p class="card-header-title">Upload Assignment</p>
            <button
              class="delete"
              aria-label="Close"
              (click)="hideAssignModal(isTopicId)"
            ></button>
          </div>
          <div class="card-content">
            <div class="content">
              <div class="field post-attach-file">
                <label
                  class="label has-tooltip-bottom"
                  data-tooltip="Upload file pdf, doc, docx, ppt, jpg, jpeg, png only"
                  >Attach File
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </label>
                <span class="has-text-danger is-size-7"
                  >Maximum file upload 5</span
                >
                <div class="file is-boxed is-fullwidth">
                  <label class="file-label">
                    <input
                      type="file"
                      name="msg-file"
                      style="display: none"
                      (change)="onSelectFileChange($event)"
                      #fileInput
                      formControlName="files"
                      accept=".jpg, .jpeg, .png, .doc, .docx, .pdf, .ppt, .pptm, .pptx"
                    />
                    <span class="file-cta">
                      <span class="file-icon">
                        <i class="fa fa-upload"></i>
                      </span>
                      <span class="file-label is-centered">
                        Upload Assignment here...
                      </span>
                    </span>
                  </label>
                </div>
              </div>
              @if (files.length > 0) {
              <div>
                @for (eachFile of files; track eachFile) {
                <div class="pos-relative">
                  <div class="file-detail">
                    <div class="content-align">
                      <p class="is-small">
                        <!-- <img  src="../../../../assets/images/file_types/{{eachFile.mimeType}}.png" width="35px" height="35px">  -->
                        {{ eachFile.name }}
                      </p>
                      <span class="file-size is-small">{{
                        eachFile.size | fileSize
                      }}</span>
                      @if (eachFile.progressVal) {
                      <progress
                        class="progress is-link is-small"
                        value="{{ eachFile.progressVal }}"
                        max="100"
                      ></progress>
                      }
                    </div>
                  </div>
                  <!-- <i class="fa fa-times" aria-hidden="true" (click)="removeFileFromList(eachFile)"></i> -->
                </div>
                }
              </div>
              } @if (preUploadedFile) {
              <div class="columns">
                <div class="column">
                  <h4>Preview User upload File</h4>
                  <div
                    class="field pos-relative scroll-bar"
                    appInfiniteScroll
                    infinite-scroll
                    [infiniteScrollDistance]="modalScrollDistance"
                    [infiniteScrollThrottle]="modalScrollThrottle"
                    [scrollWindow]="false"
                  >
                    @for (item of uploadFileIcons; track item) {
                    <div class="panel">
                      @if (item.name===preUploadedFile.file_ext) {
                      <div class="panel-block pos-relative">
                        <span>
                          <img
                            [src]="item.icons"
                            alt=""
                            width="35px"
                            height="35px"
                          />
                          {{ preUploadedFile.file_id }}</span
                        >
                        <a
                          class="icon is-small icon-align is-pulled-right"
                          (click)="removeUploadFile()"
                        >
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </a>
                      </div>
                      }
                    </div>
                    }
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          <footer class="card-footer">
            <div class="column is-12 has-text-right">
              <button
                class="button is-small mar-0-5"
                (click)="hideAssignModal(isTopicId)"
              >
                Cancel
              </button>
              @if (!showBtnSpinner) {
              <button
                class="button is-link is-small disabledBtn"
                (click)="
                  submitAssignment(uploadAssignForm.value, uploadAssignData)
                "
                [disabled]="!uploadAssignForm.valid || fileDeleted"
              >
                Submit Assignment
              </button>
              } @if (showBtnSpinner) {
              <a
                class="button is-link is-loading is-small"
                style="min-width: 100px"
              ></a>
              }
            </div>
          </footer>
        </form>
      </div>
    </div>
  </div>

  <!--FeedBack Review-->
  <div
    class="modal"
    [ngClass]="{ 'is-modal-active': assignmentFeedback[isTopicId] }"
  >
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card">
        <div class="card-header">
          <p class="card-header-title">Assignment FeedBack</p>
          <button
            class="delete"
            aria-label="Close"
            (click)="hideFeedbackModal(isTopicId)"
          ></button>
        </div>
        @if (!feedbackErrMsg) {
        <article class="message is-danger">
          <div class="message-body">
            There is no feedback provide by the Teacher
          </div>
        </article>
        } @if (feedbackErrMsg) {
        <div class="card-content">
          <div class="content is-capitalized">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label for="" class="label">Assignment Feedback</label>
                  <span [innerHTML]="feedback['feedback']"></span>
                </div>
                <div class="field">
                  <label for="" class="label">Assignment Mark (100%)</label>
                  <span [innerHTML]="feedback['marks']"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>

  <!--View Current Topic-->
  <div
    class="modal"
    [ngClass]="{ 'is-modal-active': isActiveTopic[isTopicId] }"
  >
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 850px">
      <div class="card">
        <div class="card-header">
          <p class="card-header-title">View Topic/Assignment</p>
          <button
            class="delete"
            aria-label="Close"
            (click)="hideTopicModal(isTopicId)"
          ></button>
        </div>
        <div class="card-content">
          <div class="content is-capitalized">
            <div class="columns">
              <div class="column is-5">
                <div class="field">
                  <label for="" class="label">Title</label>
                  <span>{{ getCurrentTopic["topic"] }}</span>
                </div>
                <div class="field">
                  <label for="" class="label"
                    >{{
                      getCurrentTopic["staff_type"] == "T"
                        ? "Session"
                        : "Submission"
                    }}
                    Date & Time</label
                  >
                  <span>{{
                    getCurrentTopic["shedule_date"] | date : "MMM d, y"
                  }}</span>
                </div>
                <div class="field">
                  <label for="" class="label">Type</label>
                  <span>{{
                    getCurrentTopic["staff_type"] == "T"
                      ? "Topic"
                      : "Assignment"
                  }}</span>
                </div>
                <div class="field">
                  <label for="" class="label">Description</label>
                  <span [innerHTML]="getCurrentTopic['notes']"></span>
                </div>
              </div>
              <div class="column is-7">
                @if (getCurrentTopic['file_id']!=null) {
                <div class="field">
                  <label for="" class="label">Attach File</label>
                  <!-- <div>welcome - {{getTopicDetails['file_type']}}</div> -->
                  @if (getCurrentTopic['file_type']==='video' ||
                  getCurrentTopic['file_type']==='audio') {
                  <div>
                    @if (getCurrentTopic['file_type']==='video') {
                    <div>
                      <vg-player
                        style="height: 332px"
                        (onPlayerReady)="videoPlayerInit($event)"
                      >
                        <vg-overlay-play></vg-overlay-play>
                        <vg-buffering></vg-buffering>
                        <vg-scrub-bar>
                          <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                        </vg-scrub-bar>
                        <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
                          <vg-play-pause></vg-play-pause>
                          <!-- <vg-time-display
                                  vgProperty="current"
                                  vgFormat="mm:ss"
                                ></vg-time-display> -->
                          <vg-scrub-bar
                            style="pointer-events: none"
                          ></vg-scrub-bar>
                          <vg-mute></vg-mute>
                          <vg-volume></vg-volume>
                          <vg-fullscreen></vg-fullscreen>
                        </vg-controls>
                        <video
                          #media
                          [vgMedia]="media"
                          id="singleVideo"
                          crossorigin
                        >
                          <source [src]="inputSrc" type="video/mp4" />
                        </video>
                      </vg-player>
                    </div>
                    } @else {
                    <vg-player
                      style="height: 332px"
                      (onPlayerReady)="videoPlayerInit($event)"
                    >
                      <vg-overlay-play></vg-overlay-play>
                      <vg-buffering></vg-buffering>
                      <vg-controls>
                        <vg-play-pause></vg-play-pause>
                        <!-- <vg-time-display
                              vgProperty="current"
                              vgFormat="mm:ss"
                            ></vg-time-display> -->
                        <vg-scrub-bar>
                          <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                        </vg-scrub-bar>
                        <!-- <vg-time-display
                            vgProperty="total"
                            vgFormat="mm:ss"
                          ></vg-time-display> -->
                        <vg-mute></vg-mute>
                      </vg-controls>
                      <audio
                        #audio
                        [vgMedia]="audio"
                        id="myAudio"
                        preload="none"
                      >
                        <source [src]="inputSrc" [type]="'audio/mpeg'" />
                      </audio>
                    </vg-player>
                    }
                  </div>
                  } @else { @if (getCurrentTopic['file_type']==='image') {
                  <div class="">
                    <img
                      class="thumb_img"
                      style="height: 332px"
                      [src]="getCurrentTopic['view_url']"
                    />
                  </div>
                  } @else { @if (showFileLoadSpinner) {
                  <span
                    class="is-loading"
                    style="position: absolute; top: 35%; left: 43%"
                  >
                    <img
                      src="../../../../../../assets/images/loader-dot-small.gif"
                      alt=""
                    />
                  </span>
                  }
                  <ngx-doc-viewer
                    url="{{ selectedReadFile }}"
                    googleCheckContentLoaded="true"
                    googleCheckInterval="3000"
                    googleMaxChecks="5"
                    viewer="google"
                    style="width: 100%; height: 600px; z-index: 999"
                  >
                  </ngx-doc-viewer>
                  } }
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (studyRoomDataList.length===0) {
  <div class="common-empty topic-notify box">
    <article class="media">
      <div class="media-content has-text-centered">
        <!-- <img [src]="'../../../../assets/images/notification_empty.svg'"> -->
        <p>No Topic/Assignment List found</p>
      </div>
    </article>
  </div>
  }
</div>
